import { Nullable } from "../../@typings/typings";
import { FieldError } from "react-hook-form/dist/types";

export function requiredFieldErrorMessage(error: Nullable<FieldError>): string {
	return error ? "Обязательное поле" : "";
}

export function requiredQuestionDifficultMessage(error: Nullable<FieldError>): string {
	return error ? "Выберите сложность" : "";
}

export function requiredQuestionTopicMessage(error: Nullable<FieldError>): string {
	return error ? "Выберите минимум одну тему" : "";
}
